<template lang="pug">
.section
  .section-header
    .section-header-back
      a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
        i.fas.fa-arrow-left
    h1 {{ $t("ui.daily_deposit_affiliate") }}
    .section-header-breadcrumb
      .breadcrumb-item
        router-link(to="/affiliate/affiliateList") {{ $t("ui.affiliate_list") }}
      .breadcrumb-item.active
        router-link(to="/affiliate/dailyDepositAffiliate") {{ $t('ui.daily_deposit_affiliate') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .col-md-2.col-2.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-tie
                  DebounceInput(required autofocus type="text" v-model="searchAffiliateID" :placeholder="$t('message.search_by_account_id')" @enter="getListing()" size="sm")
              .col-md-8.col-8.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .col-md-12.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListing()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-md-12.col-12
                b-breadcrumb
                  b-breadcrumb-item(
                    @click="drillIn('company')"
                  )
                    span {{ accountID }}
                  b-breadcrumb-item(
                    v-if="operatorID"
                    :class="{ active : lines.length == 0 }"
                    @click="drillIn(null, 'operator', operatorID)"
                  )
                    span {{ operatorID }}
                  b-breadcrumb-item(
                    v-for="(item,index) in lines"
                    :key="index"
                    :text="item.account_id"
                    :class="{ active : index == lines.length - 1 }"
                    @click="drillIn(item, 'affiliate')"
                  )
            .row(v-if="selectedAffiliateAccType < 10")
              .col-12
                .card.card-primary
                  .card-header
                    i.fa.fa-user-tie
                    span.ml-1.font-weight-bold(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
                  .card-body
                    .row
                      .col-md-10.col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="totalRowAff"
                          :per-page="getPageSize"
                          v-model="currentPageAff"
                          @input="changedPageAff($event)"
                        )
                      .col-md-2.col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeAff" size="sm")
                      .col-md-12.col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(rowspan=2 width="3%")
                                  span #
                                th(rowspan=2 width="17%" @click="sortOrder('account_id','aff')")
                                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                                  .float-right
                                    i(:class="changeSortKey('account_id','aff')")
                                th.text-center(colspan=4 width="40%")
                                  span(:title="$t('ui.downline')") {{ $t('ui.downline') }}  
                                th.text-center(colspan=4 width="40%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                              tr
                                th.text-right(width="9%" @click="sortOrder('deposit_amount_downline','aff')")
                                  span(:title="$t('ui.deposit_amount_downline')") {{ $t('ui.deposit_amount') }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_amount_downline','aff')")
                                th.text-right(width="8%" @click="sortOrder('deposit_count_downline','aff')")
                                  span(:title="$t('ui.deposit_count_downline')") {{ $t('ui.deposit_count') }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_count_downline','aff')")
                                th.text-right(width="8%" @click="sortOrder('bonus_amount_downline','aff')")
                                  span(:title="$t('ui.bonus_amount_downline')") {{ $t('ui.bonus_amount') }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_amount_downline','aff')")
                                th.text-right(width="8%" @click="sortOrder('bonus_count_downline','aff')")
                                  span(:title="$t('ui.bonus_count_downline')") {{ $t("ui.bonus_count") }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_count_downline','aff')")
                                th.text-right(width="8%" @click="sortOrder('deposit_amount_member','aff')")
                                  span(:title="$t('ui.deposit_amount_member')") {{ $t("ui.deposit_amount") }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_amount_member','aff')")
                                th.text-right(width="8%" @click="sortOrder('deposit_count_member','aff')")
                                  span(:title="$t('ui.deposit_count_member')") {{ $t("ui.deposit_count") }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_count_member','aff')")
                                th.text-right(width="8%" @click="sortOrder('bonus_amount_member','aff')")
                                  span(:title="$t('ui.bonus_amount_member')") {{ $t("ui.bonus_amount") }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_amount_member','aff')")
                                th.text-right(width="8%" @click="sortOrder('bonus_count_member','aff')")
                                  span(:title="$t('ui.bonus_count_member')") {{ $t("ui.bonus_count") }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_count_member','aff')")
                            tbody.clusterize-content
                              tr(v-if="affList.length == 0")
                                td(colspan="10").text-center
                                  span {{ $t('message.no_data_available') }}
                              template(v-for="(item, index) in affList")
                                tr
                                  td.text-center
                                    span(:title="((currentPageAff - 1) * getPageSize + index + 1)") {{ ((currentPageAff - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.account_id")
                                      b-link.clickable(href="javascript:void(0);" @click="drillIn(item, 'affiliate')") {{ item.account_id }}
                                  td.text-right
                                    span(:title="$n(item.deposit_amount_downline, 'currency')") {{ $n(item.deposit_amount_downline, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.deposit_count_downline, 'integer')") {{ $n(item.deposit_count_downline, 'integer') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_amount_downline, 'currency')") {{ $n(item.bonus_amount_downline, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_count_downline, 'integer')") {{ $n(item.bonus_count_downline, 'integer') }}
                                  td.text-right
                                    span(:title="$n(item.deposit_amount_member, 'currency')") {{ $n(item.deposit_amount_member, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.deposit_count_member, 'integer')") {{ $n(item.deposit_count_member, 'integer') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_amount_member, 'currency')") {{ $n(item.bonus_amount_member, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_count_member, 'integer')") {{ $n(item.bonus_count_member, 'integer') }}
                              tr(v-if="showTotalAff")
                                td.text-right(colspan="2")
                                  span {{ $t("ui.sub_total") }}
                                  br
                                  span {{ $t("ui.grand_total") }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountDownline)" :title="$n(subTotalDepositAmountDownline, 'currency')") {{ $n(subTotalDepositAmountDownline, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountDownline)" :title="$n(grandTotalDepositAmountDownline, 'currency')") {{ $n(grandTotalDepositAmountDownline, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCountDownline)" :title="$n(subTotalDepositCountDownline, 'integer')") {{ $n(subTotalDepositCountDownline, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCountDownline)" :title="$n(grandTotalDepositCountDownline, 'integer')") {{ $n(grandTotalDepositCountDownline, 'integer') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountDownline)" :title="$n(subTotalBonusAmountDownline, 'currency')") {{ $n(subTotalBonusAmountDownline, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountDownline)" :title="$n(grandTotalBonusAmountDownline, 'currency')") {{ $n(grandTotalBonusAmountDownline, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusCountDownline)" :title="$n(subTotalBonusCountDownline, 'integer')") {{ $n(subTotalBonusCountDownline, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusCountDownline)" :title="$n(grandTotalBonusCountDownline, 'integer')") {{ $n(grandTotalBonusCountDownline, 'integer') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountMember)" :title="$n(subTotalDepositAmountMember, 'currency')") {{ $n(subTotalDepositAmountMember, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountMember)" :title="$n(grandTotalDepositAmountMember, 'currency')") {{ $n(grandTotalDepositAmountMember, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCountMember)" :title="$n(subTotalDepositCountMember, 'integer')") {{ $n(subTotalDepositCountMember, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCountMember)" :title="$n(grandTotalDepositCountMember, 'integer')") {{ $n(grandTotalDepositCountMember, 'integer') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountMember)" :title="$n(subTotalBonusAmountMember, 'currency')") {{ $n(subTotalBonusAmountMember, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountMember)" :title="$n(grandTotalBonusAmountMember, 'currency')") {{ $n(grandTotalBonusAmountMember, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusCountMember)" :title="$n(subTotalBonusCountMember, 'integer')") {{ $n(subTotalBonusCountMember, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusCountMember)" :title="$n(grandTotalBonusCountMember, 'integer')") {{ $n(grandTotalBonusCountMember, 'integer') }}
            .row(v-if="selectedAffiliateID")
              .col-12
                .card.card-secondary
                  .card-header
                    i.fa.fa-user
                    span.ml-1.font-weight-bold(:title="$t('ui.member')") {{ $t("ui.member") }}
                  .card-body
                    .row
                      .col-md-10.col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="totalRowMbm"
                          :per-page="getPageSize"
                          v-model="currentPageMbm"
                          @input="changedPageMbm($event)")
                      .col-md-2.col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeMbm" size="sm")
                      .col-md-12.col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="9%" @click="sortOrder('account_id','mbm')")
                                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                                  .float-right
                                    i(:class="changeSortKey('account_id','mbm')")
                                th.text-right(width="9%" @click="sortOrder('deposit_amount','mbm')")
                                  span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_amount','mbm')")
                                th.text-right(width="8%" @click="sortOrder('deposit_count','mbm')")
                                  span(:title="$t('ui.deposit_count')") {{ $t('ui.deposit_count') }}
                                  .float-right
                                    i(:class="changeSortKey('deposit_count','mbm')")
                                th.text-right(width="8%" @click="sortOrder('bonus_amount','mbm')")
                                  span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_amount','mbm')")
                                th.text-right(width="8%" @click="sortOrder('bonus_count','mbm')")
                                  span(:title="$t('ui.bonus_count')") {{ $t("ui.bonus_count") }}
                                  .float-right
                                    i(:class="changeSortKey('bonus_count','mbm')")
                            tbody.clusterize-content
                              tr(v-if="mbmList.length == 0")
                                td(colspan="6").text-center
                                  span {{ $t('message.no_data_available') }}
                              template(v-for="(item, index) in mbmList")
                                tr
                                  td.text-center
                                    span(:title="((currentPageMbm - 1) * getPageSize + index + 1)") {{ ((currentPageMbm - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.account_id") {{ item.account_id }}
                                  td.text-right
                                    span(:title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.deposit_count, 'currency')") {{ $n(item.deposit_count, 'integer') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                                  td.text-right
                                    span(:title="$n(item.bonus_count, 'integer')") {{ $n(item.bonus_count, 'integer') }}
                              tr(v-if="showTotalMbm")
                                td.text-right(colspan="2")
                                  span {{ $t("ui.sub_total") }}
                                  br
                                  span {{ $t("ui.grand_total") }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCount)" :title="$n(subTotalDepositCount, 'integer')") {{ $n(subTotalDepositCount, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCount)" :title="$n(grandTotalDepositCount, 'integer')") {{ $n(grandTotalDepositCount, 'integer') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusCount)" :title="$n(subTotalBonusCount, 'integer')") {{ $n(subTotalBonusCount, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusCount)" :title="$n(grandTotalBonusCount, 'integer')") {{ $n(grandTotalBonusCount, 'integer') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    affList: [],
    mbmList: [],
    lines: [],
    currentPageAff: 1,
    totalRowAff: 0,
    currentPageMbm: 1,
    totalRowMbm: 0,
    searchAffiliateID: "",
    selectedAffiliateID: "",
    selectedAffiliateAccType: "",
    dateRange: {
      startDate: null,
      endDate: null
    },
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKeyAff: "account_id",
    sortTypeAff: "asc",
    sortKeyMbm: "account_id",
    sortTypeMbm: "asc",
    showTotalAff: false,
    showTotalMbm: false,
    subTotalDepositAmountDownline: 0,
    grandTotalDepositAmountDownline: 0,
    subTotalDepositCountDownline: 0,
    grandTotalDepositCountDownline: 0,
    subTotalBonusAmountDownline: 0,
    grandTotalBonusAmountDownline: 0,
    subTotalBonusCountDownline: 0,
    grandTotalBonusCountDownline: 0,

    subTotalDepositAmountMember: 0,
    grandTotalDepositAmountMember: 0,
    subTotalDepositCountMember: 0,
    grandTotalDepositCountMember: 0,
    subTotalBonusAmountMember: 0,
    grandTotalBonusAmountMember: 0,
    subTotalBonusCountMember: 0,
    grandTotalBonusCountMember: 0,

    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalDepositCount: 0,
    grandTotalDepositCount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalBonusCount: 0,
    grandTotalBonusCount: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

    this.getListing();
  },
  methods: {
    redirect() {
      // this.$store.dispatch("user/setSelectedOperatorID", "");
      this.$router.push("/affiliate/affiliateList");
    },
    getListing() {
      if (this.checkDateRange()) {
        this.getDailyDepositAff(true);
        // this.getDailyDepositMbm(true);
        if(this.selectedAffiliateID) {
          this.getDailyDepositMbm(true);
        }
      } else {
        this.clearTotalAff();
        // this.clearTotalMbm();
        if(this.selectedAffiliateID) {
          this.clearTotalMbm();
        }
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    sortOrder(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff == key)
          this.sortTypeAff = this.sortTypeAff == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyAff = key;
          this.sortTypeAff = 'asc';
        }
        this.getDailyDepositAff(true);
      } else if (type == 'mbm') {
        if (this.sortKeyMbm == key)
          this.sortTypeMbm = this.sortTypeMbm == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyMbm = key;
          this.sortTypeMbm = 'asc';
        }
        this.getDailyDepositMbm(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff != key)
          return 'fas fa-sort';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'mbm') {
        if (this.sortKeyMbm != key)
          return 'fas fa-sort';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'desc')
          return 'fa fa-sort-down';
      }
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListing();
    },
    drillIn: function (item, mode, id) {
      this.affList = ""
      this.showTotalAff = false
      this.mbmList = ""
      this.showTotalMbm = false

      if(item == 'company') {
        this.selectedAffiliateID = "";
      }

      if(mode == 'operator') {
        this.selectedAffiliateID = "";
      }

      if(mode == 'affiliate') {
        this.selectedAffiliateID = item.account_id;
      }

      this.searchAffiliateID = ""
      this.getListing();
    },
    clearTotalAff() {
      this.showTotalAff = false
      this.affList = []
      this.totalRowAff = 0
      this.subTotalDepositAmountDownline = 0
      this.grandTotalDepositAmountDownline = 0
      this.subTotalDepositCountDownline = 0
      this.grandTotalDepositCountDownline = 0
      this.subTotalBonusAmountDownline = 0
      this.grandTotalBonusAmountDownline = 0
      this.subTotalBonusCountDownline = 0
      this.grandTotalBonusCountDownline = 0
      this.subTotalDepositAmountMember = 0
      this.grandTotalDepositAmountMember = 0
      this.subTotalDepositCountMember = 0
      this.grandTotalDepositCountMember = 0
      this.subTotalBonusAmountMember = 0
      this.grandTotalBonusAmountMember = 0
      this.subTotalBonusCountMember = 0
      this.grandTotalBonusCountMember = 0
    },
    clearTotalMbm() {
      this.showTotalMbm = false
      this.mbmList = []
      this.totalRowMbm = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalDepositCount = 0
      this.grandTotalDepositCount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalBonusCount = 0
      this.grandTotalBonusCount = 0
    },
    getDailyDepositAff: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyDepositAffUrl();

        if (isSearch) this.currentPageAff = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          search_id: this.searchAffiliateID || this.selectedAffiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKeyAff,
          sort_type: this.sortTypeAff,
          page_number: this.currentPageAff,
          page_size: this.getPageSize,
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalAff()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.deposit.length > 0) {
                    this.showTotalAff = true;
                    response.data.ds.deposit.forEach(value => {
                      this.subTotalDepositAmountDownline = parseFloat(this.subTotalDepositAmountDownline) + parseFloat(value["deposit_amount_downline"]);
                      this.subTotalDepositCountDownline = parseInt(this.subTotalDepositCountDownline) + parseInt(value["deposit_count_downline"]);
                      this.subTotalBonusAmountDownline = parseFloat(this.subTotalBonusAmountDownline) + parseFloat(value["bonus_amount_downline"]);
                      this.subTotalBonusCountDownline = parseInt(this.subTotalBonusCountDownline) + parseInt(value["bonus_count_downline"]);
                      this.subTotalDepositAmountMember = parseFloat(this.subTotalDepositAmountMember) + parseFloat(value["deposit_amount_member"]);
                      this.subTotalDepositCountMember = parseInt(this.subTotalDepositCountMember) + parseInt(value["deposit_count_member"]);
                      this.subTotalBonusAmountMember = parseFloat(this.subTotalBonusAmountMember) + parseFloat(value["bonus_amount_member"]);
                      this.subTotalBonusCountMember = parseInt(this.subTotalBonusCountMember) + parseInt(value["bonus_count_member"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalDepositAmountDownline = response.data.ds.grand_total[0]["deposit_amount_downline"];
                      this.grandTotalDepositCountDownline = response.data.ds.grand_total[0]["deposit_count_downline"];
                      this.grandTotalBonusAmountDownline = response.data.ds.grand_total[0]["bonus_amount_downline"];
                      this.grandTotalBonusCountDownline = response.data.ds.grand_total[0]["bonus_count_downline"];
                      this.grandTotalDepositAmountMember = response.data.ds.grand_total[0]["deposit_amount_member"];
                      this.grandTotalDepositCountMember = response.data.ds.grand_total[0]["deposit_count_member"];
                      this.grandTotalBonusAmountMember = response.data.ds.grand_total[0]["bonus_amount_member"];
                      this.grandTotalBonusCountMember = response.data.ds.grand_total[0]["bonus_count_member"];
                    }

                    this.affList = response.data.ds.deposit;
                    this.totalRowAff = response.data.ds.deposit.length > 0 ? this.affList[0].totalrows : 0;
                  } else {
                    this.clearTotalAff()
                  }
                  if (response.data.ds.line.length > 0) {
                    this.lines = response.data.ds.line.sort(function(a, b) {
                      return a.account_type - b.account_type;
                    });
                    let list = this.lines.find(item => item.account_id === this.selectedAffiliateID);
                    this.selectedAffiliateAccType = list.account_type;
                  } else {
                    this.lines = [];
                    this.selectedAffiliateAccType = "";
                  }
                } else {
                  this.clearTotalAff()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalAff();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getDailyDepositMbm: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyDepositMemberAffUrl();

        if (isSearch) this.currentPageMbm = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          account_id: this.selectedAffiliateID,
          search_id: this.searchAffiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKeyMbm,
          sort_type: this.sortTypeMbm,
          page_number: this.currentPageMbm,
          page_size: this.getPageSize,
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalMbm()
            this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              if(response.data.ds.deposit.length > 0) {
                this.showTotalMbm = true;
                response.data.ds.deposit.forEach(value => {
                  this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
                  this.subTotalDepositCount = parseFloat(this.subTotalDepositCount) + parseFloat(value["deposit_count"]);
                  this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
                  this.subTotalBonusCount = parseFloat(this.subTotalBonusCount) + parseInt(value["bonus_count"]);
                });

                if(response.data.ds.grand_total.length > 0) {
                  this.grandTotalDepositAmount = response.data.ds.grand_total[0]["deposit_amount"];
                  this.grandTotalDepositCount = response.data.ds.grand_total[0]["deposit_count"];
                  this.grandTotalBonusAmount = response.data.ds.grand_total[0]["bonus_amount"];
                  this.grandTotalBonusCount = response.data.ds.grand_total[0]["bonus_count"];
                }

                this.mbmList = response.data.ds.deposit;
                this.totalRowMbm = response.data.ds.deposit.length > 0 ? this.mbmList[0].totalrows : 0;
              } else {
                this.clearTotalMbm()
              }
            } else {
              this.clearTotalMbm()
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );

      } else {
        this.clearTotalMbm();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSizeAff: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAff = 1;
      this.getDailyDepositAff(true);
    },
    changedPageAff: function(pageNo) {
      this.currentPageAff = pageNo;
      this.getDailyDepositAff();
    },
    changedPageSizeMbm: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageMbm = 1;
      this.getDailyDepositMbm(true);
    },
    changedPageMbm: function(pageNo) {
      this.currentPageMbm = pageNo;
      this.getDailyDepositMbm();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>